import styled from "styled-components";

export const Main=styled.div`
 width: 70%;
 margin: auto;
 border: 1px solid transparent;
 height: 800px;
 
`;

export const SignBox=styled.div` 
margin-top: 2%;
justify-content: space-around;
display: flex;

`;

export const HEAD=styled.div` 
font-size: xx-large;
margin-bottom: 10%;
font-weight: bolder;
margin-left: 10%;
`;

export const Signed=styled.div` 
width: 40%;
border: 1px solid transparent;

`;

export const TopBar=styled.div` 
margin-top: 15%;
display: flex;
justify-content: space-around;
`;



export const Label=styled.label` 
font-size: large;
margin:2% 0% 2% 25%;
text-align: center;
`;

export const Label1=styled.label` 
 margin-bottom: 10px;
`;

export const Input=styled.input` 
   height: 33px;
   padding-left: 5px;
   margin-bottom: 20px;  
   width: 77%; 
   border :1px solid lightgray ;
`;

export const INPUT=styled.input` 
   padding-left: 4px;
   width:65%;
   height: 33px;
   margin-bottom: 20px;
   border: 1px solid lightgray;
   
`;

export const Flex=styled.div` 
  display: flex;
  border: 1px solid transparent;
`;

export const Hori=styled.hr` 
background-color : lightslategray;
`;

export const Create=styled.button` 
 height: 44px;
 width: 80%;
 border-radius: 3px;
 font-size: large;
 border: none;
 background-color: rgb(2,108,154);
 color: whitesmoke;
 margin-bottom: 20px;
 cursor: pointer;
`;


export const Continue=styled.button` 
margin-top: 5%;
height: 44px;
border-radius: 3px;
width: 80%;
cursor: pointer;
font-size: large;
border: 1px solid lightgray;
color: gray;

`;


export const Login=styled.button` 
margin-top: 2%;
border: none;
height: 44px;
 width: 80%;
 cursor: pointer;
 font-size: large;
 background-color: rgb(39,134,95);
 color: whitesmoke;
`;

export const Para=styled.p` 
width: 80%;
border: 1px solid transparent;
padding-left: 10px;
margin-bottom: 15px;
`

export const Signed1=styled.div` 
width: 1px;
background-color: lightgray;
`;